<template>
  <div class="user-search" @click.passive="$emit('click')">
    <nuxt-link :to="user.link" class="user-search__link" />
    <Avatar type="extra-small" :title="initials" :src="image" class="user-search__avatar" />
    <div class="user-search__info">
      <div class="user-search__name">{{ name }}</div>
      <div class="user-search__position">{{ user.position }}</div>
      <div class="user-search__location">{{ location }}</div>
    </div>
    <div class="user-search__score">
      <MenuScoreIcon class="user-search__icon" />
      {{ user.score }}
    </div>
  </div>
</template>

<script>
import MenuScoreIcon from '~/assets/svg/menu-score.vue.svg';
import Avatar from '~/components/common/Avatar/AvatarLink.vue';
import { initials } from '~/components/utils/core/string';
import { chunk } from '~/components/utils/core/array';

// eslint-disable-next-line import/prefer-default-export
const getAvatarUrl = ({ resource, field, type, id, path }) => {
  if (!path) return '/missing.png';
  const prefix = chunk(String(`000000000${id}`).slice(-9), 3);
  return ['https://static-production.bravado.co', resource, field, ...prefix, type, path].join('/');
};

export default {
  name: 'SearchUser',
  components: {
    Avatar,
    MenuScoreIcon,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      return [this.user.firstname, this.user.lastname].join(' ');
    },
    location() {
      const address = [this.user.city_name, this.user.country_name].filter(i => i).join(', ') || null;
      if (!address) return this.user.current_company;
      if (!this.user.current_company) return address;
      return `${this.user.current_company} • ${address}`;
    },
    image() {
      return getAvatarUrl({
        id: this.user.user_id,
        resource: 'users',
        field: 'avatars',
        type: 'original',
        path: this.user.avatar_file_name,
      });
    },
    initials() {
      return initials(this.name);
    },
  },
};
</script>

<style scoped lang="scss">
$font: var(--font-family);
$name-color: var(--universal-color-gray-3);
$position-color: var(--universal-color-gray-20);
$location-color: var(--universal-color-gray-50);
$score-color: var(--universal-color-white);
$score-font: var(--font-family);
$avatar-font: var(--font-family);

.user-search {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  position: relative;

  * {
    @include caption1;
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__avatar {
    // fixme: no such typography mixin

    font-family: $avatar-font;
    line-height: 2;
    font-size: 12px;
    margin-top: 6px;
    flex: 0 0 24px;
  }

  &__info {
    flex: 1;
    margin-left: 10px;
  }

  &__name {
    color: $name-color;
  }

  &__position {
    margin-top: 4px;
    color: $position-color;
  }

  &__location {
    margin-top: 6px;
    color: $location-color;
  }

  &__score {
    font-family: $score-font;
    margin-left: 11px;
    padding: 12px 0 0;
    font-size: 9px;
    line-height: 1.14;
    display: flex;
    align-items: center;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: $score-color;
    font-weight: bold;
  }

  &__icon {
    margin-right: 4px;
    width: 6px;
    height: 7px;
  }
}
</style>
